import React from 'react';
import { Paper, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';
import { contentCardSx } from '../../../../styles/standaloneLayoutTokens';

function formatDateLabel(dateStr) {
  const [, m, d] = dateStr.split('-');
  return `${parseInt(m, 10)}/${parseInt(d, 10)}`;
}

export default function PatientMixChart({ data }) {
  const theme = useTheme();

  if (!data || data.length === 0) return null;

  const hasAny = data.some(d => d.new > 0 || d.returning > 0);
  if (!hasAny) return null;

  return (
    <Paper elevation={0} sx={{ ...contentCardSx, p: 2.5 }}>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
        New vs Returning Patients
      </Typography>

      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={data} margin={{ top: 4, right: 8, left: -16, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
          <XAxis
            dataKey="date"
            tickFormatter={formatDateLabel}
            tick={{ fontSize: 12 }}
            stroke={theme.palette.text.secondary}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fontSize: 12 }}
            stroke={theme.palette.text.secondary}
          />
          <Tooltip
            labelFormatter={formatDateLabel}
            contentStyle={{
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: 8,
            }}
          />
          <Legend />
          <Bar
            dataKey="new"
            name="New Patients"
            stackId="mix"
            fill={theme.palette.success.main}
            radius={[0, 0, 0, 0]}
          />
          <Bar
            dataKey="returning"
            name="Returning"
            stackId="mix"
            fill={theme.palette.primary.main}
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
}
